import type { Logger } from "../../ports/logger";

export const createConsoleLogger = (): Logger => ({
  debug: (message, context) => console.debug(message, context),
  info: (message, context) => console.info(message, context),
  warn: (message, context) => console.warn(message, context),
  error: (message, context) => console.error(message, context),
});
